/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} WeekInputs */

const en_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`week`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`weeks`);
	return /** @type {LocalizedString} */ ("week");
};

const th_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`สัปดาห์`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`สัปดาห์`);
	return /** @type {LocalizedString} */ ("week");
};

const ja_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`週`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`週間`);
	return /** @type {LocalizedString} */ ("week");
};

const fr_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`semaine`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`semaines`);
	return /** @type {LocalizedString} */ ("week");
};

const es_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`semana`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`semanas`);
	return /** @type {LocalizedString} */ ("week");
};

const ru_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`неделя`);
	if (countPlural === "few") return /** @type {LocalizedString} */ (`недели`);
	if (countPlural === "many") return /** @type {LocalizedString} */ (`недель`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`недель`);
	return /** @type {LocalizedString} */ ("week");
};

const zh_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`周`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`周`);
	return /** @type {LocalizedString} */ ("week");
};

const vi_week = /** @type {(inputs: WeekInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`tuần`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`tuần`);
	return /** @type {LocalizedString} */ ("week");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "week" |
* | "other" | "weeks" |
*
* @param {WeekInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const week = /** @type {((inputs: WeekInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WeekInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_week(inputs)
	if (locale === "ja") return ja_week(inputs)
	if (locale === "fr") return fr_week(inputs)
	if (locale === "es") return es_week(inputs)
	if (locale === "ru") return ru_week(inputs)
	if (locale === "zh") return zh_week(inputs)
	if (locale === "vi") return vi_week(inputs)
	return en_week(inputs)
});